<template>
  <v-app>
    <v-card>
      <v-card-text class="mt-5">
        <v-alert
          class="alert-warn mb-10"
          v-if="data.status == 'pending'"
          border="bottom"
          colored-border
          type="info"
          elevation="2"
        >
          <h2>اطلاعات شبکه اجتماعی شما برای برسی ارسال شده است.</h2>
          <p></p>
          <p></p>
          <h4>
            تا زمانی که اطلاعات شما توسط مدیریت تایید نشود قادر به ویرایش
            اطلاعات خود نخواهید بود.
          </h4>
        </v-alert>

        <v-alert
          class="alert-danger mb-10"
          v-else-if="data.reject_text && data.status == 'reject'"
          border="bottom"
          colored-border
          type="error"
          elevation="2"
        >
          <h2>اطلاعات شما رد شده است.</h2>
          <br />
          <h4 v-for="(x, i) in data.reject_text.split('\n')">
            {{ i + 1 }} : {{ x }}
          </h4>
        </v-alert>

        <v-row class="my-5">
          <back-button></back-button>
          <v-divider></v-divider>
        </v-row>

        <v-row
          class="flex-sm-column flex-md-row flex-md-nowrap justify-content-center align-items-center"
        >
          <v-row class="d-flex flex-row align-items-center mx-2">
            <v-col class="col-12 col-md-6">
              <v-text-field
                class="m-1"
                label="نام مجموعه"
                v-model="data.name"
                :rules="rules.text"
                :disabled="data.status == 'pending'"
                outlined
                :error-messages="errors['name']"
              ></v-text-field>

              <v-autocomplete
                v-model="data.type"
                disabled
                :items="orderTypes"
                item-text="keyAlias"
                item-value="key"
                :error-messages="errors !== undefined ? errors.type : []"
                label="نوع سفارش"
                outlined
              ></v-autocomplete>
            </v-col>

            <v-col class="col-12 col-md-6">
              <site-select
                v-model="data.site_type"
                :value="data.site_type"
                :dense="false"
              ></site-select>

              <programming-select
                v-model="data.programming_language"
                :value="data.programming_language"
              ></programming-select>
            </v-col>
          </v-row>
        </v-row>

        <hr />

        <!--                SEO-->

        <v-row class="justify-content-center" v-if="data.type === 'seo'">
          <key-value
            :value="data.rivals"
            main-label="سایت های رقبا"
            key-label="لینک سایت"
            value-label="توضیحات"
          ></key-value>
        </v-row>
        <v-row v-if="data.type === 'seo'">
          <prop-selector
            :label="'کلمات کلیدی مد نظرتان را بنویسید و کلید Enter را فشار دهید'"
          ></prop-selector>
        </v-row>
        <v-divider></v-divider>

        <v-row
          class="mt-5 flex-column"
          v-if="data.type === 'design' || data.type === 'support'"
        >
          <v-row>
            <v-col class="py-2 px-4" v-if="data.type === 'design'">
              <site-value v-model="data.quality"></site-value>
            </v-col>

            <v-col class="py-2 px-4" v-if="data.type === 'support'">
              <v-text-field
                outlined
                class="mt-2"
                :error-messages="errors !== undefined ? errors.description : []"
                v-model="data.support_time"
                type="number"
                label="مدت زمان پشتیبانی(ماه)"
                append-icon="mdi-date"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-2 px-4" v-if="data.type === 'design'">
              <key-value
                :value="data.recommended_sites"
                main-label="سایت های پیشنهادی"
                key-label="لینک سایت"
                value-label="توضیحات"
              ></key-value>
            </v-col>
          </v-row>
        </v-row>

        <v-divider />

        <v-row>
          <v-textarea
            class="m-1"
            outlined
            name="input-7-4"
            label="توضیحات"
            v-model="data.description"
            :disabled="data.status == 'pending'"
            :rules="rules.address"
            :error-messages="errors['description']"
          ></v-textarea>
        </v-row>
        <!--        :disabled="!isValid"-->
        <v-row v-if="siteid" class="justify-content-center">
          <v-btn
            width="80%"
            class="btn-update"
            @click="update()"
            :disabled="data.status == 'pending'"
          >
            <v-icon class="ml-1">mdi-content-save-edit</v-icon>
            به روز رسانی
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-app>
</template>

<script>
import { ir } from "../../../check_domain_ir";
export default {
  name: "create",
  data() {
    return {
      images: [],
      socials: [
        {
          id: 1,
          description: "اینستاگرام",
          icon: "/media/social/instagram.png",
        },
        {
          id: 2,
          description: "تلگرام",
          icon: "/media/social/telegram.png",
        },
        {
          id: 3,
          description: "آپارات",
          icon: "/media/social/aparat.png",
        },
        {
          id: 4,
          description: "روبیکا",
          icon: "/media/social/rubika.png",
        },
        {
          id: 5,
          description: "آی گپ",
          icon: "/media/social/igap.png",
        },
        {
          id: 6,
          description: "یوتیوب",
          icon: "/media/social/youtube.png",
        },
        {
          id: 7,
          description: "گپ",
          icon: "/media/social/gap.png",
        },
        {
          id: 8,
          description: "بله",
          icon: "/media/social/bale.png",
        },
      ],
      rCities: [],
      orderTypes: [
        {
          key: "design",
          keyAlias: "طراحی سایت",
          icon: "/media/site/aparat.png",
        },
        {
          key: "support",
          keyAlias: "پشتیبانی سایت",
          icon: "/media/site/aparat.png",
        },
        { key: "seo", keyAlias: "سئو سایت", icon: "/media/site/aparat.png" },
      ],
      cities: [],
      provinces: [],
      term: "نقد",
      owner_radio: "1",
      appUrl: process.env.VUE_APP_API_URL,
      data: {
        name: "",
        site_type: null,
        programming_language: null,
        social_id: null,
        avatar: null,
        follower: 0,
        likeAvg: 0,
        commentAvg: 0,
        viewAvg: 0,
        owner: "1",
        owner_fullname: "",
        link: "",
        history: "",
        category: "",
        province: "",
        city: "",
        pricings: [],
        images: [],
        description: "",
      },

      gateways: [],
      selectedSocial: null,
      items: [
        "ورزشی",
        "هنری",
        "خودرو",
        "غذا",
        "اشپزی",
        "موسیقی",
        "طنز و سرگرمی",
        "فناوری و تکنولوژی",
        "اخبار",
        "بورس",
        "فیلم و سینما",
        "مذهبی",
        "مد و فشن",
        "اموزشی",
        "برنامه نویسی",
        "سفر",
        "کسب و کار",
        "علمی",
        "پزشکی",
        "نجوم",
        "فروشگاه",
      ],
      mainModel: [],
      search: null,

      video: {
        isSelecting: false,
      },

      rules: {
        text: [(v) => !!(v ?? "").trim() || "لطفا مقداری وارد کنید."],
        mosabatMokhalefSefr: [
          (v) =>
            Math.sign(v) === 1 || "مقدار وارد شده باید عدد و بزرگتر از 0 باشد.",
        ],
        address: [
          (v) =>
            !((v ?? "").length < 4 || (v ?? "").length > 5000) ||
            "مقدار وارد شده باید بزرگتر از 4 کاراکتر و حد اکثر 5 هزار کاراکتر باشد",
        ],
      },

      typeSuggest: [],

      showSuggest: [],
      typeSearch: "",
      errors: [],
      isOkey: true,
      siteid: null,
      billData: [],
      billImages: [],
      once: true,
      centerItems: [],
    };
  },
  created() {
    this.fetch();
  },
  computed: {
    baseUrl() {
      return this.$appApiUrl + "/storage/";
    },

    isValid() {
      let flag = true;

      flag &&= this.data.avatar;

      flag &&= this.data.follower >= 0;
      flag &&= this.data.commentAvg >= 0;
      flag &&= this.data.likeAvg >= 0;
      flag &&= this.data.viewAvg >= 0;

      flag &&= this.data.owner == "0" ? this.data.owner_fullname : true;

      flag &&= this.data.link;

      flag &&= this.data.history;

      return flag;
    },
  },
  methods: {
    fetch() {
      if (this.$route.params.id) {
        this.siteid = this.$route.params.id;
        this.once = false;

        this.requestApiGet(`site/${this.siteid}`)
          .then((res) => {
            this.data = res.data;
          })
          .catch((err) => console.log(err));
      }
    },

    update() {
      // this.$modal.showLoading();
      let temp = this.createFormData(this.data);
      temp.append("_method", "PUT");
      this.requestApiPost(`site/${this.siteid}`, temp)
        .then((res) => {
          console.log(res);
          if (res.status) {
            this.goto("site");
            this.$toast.success("با موفقیت ثبت شد.");
          } else {
            this.$toast.warning("لطفا مجددا تلاش کنید");
          }
        })
        .catch((e) => {
          this.$toast.error("خطا در ثبت");
          console.log(e);
          this.errors = e.response.data.errors;
        })
        .finally(() => {
          this.$modal.hideLoading();
        });
    },
    isValidTextAddress(v) {
      return !((v ?? "").length < 4 || (v ?? "").length > 5000);
    },
    handleFileImport() {
      this.video.isSelecting = true;
      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener(
        "focus",
        () => {
          this.video.isSelecting = false;
        },
        { once: true }
      );
      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },

    changeCities() {
      let id = this.data.province;
      this.rCities = [];
      for (let city of this.cities) {
        if (city.province_id == id) {
          this.rCities.push(city);
        }
      }
    },
  },
};
</script>

<style>
.imageSelectorContainer .layout {
  justify-content: center !important;
}

.imageSelectorContainer button.success {
  height: 3rem;
  background-color: transparent !important;
}

.imageSelectorContainer button.success:hover {
  color: white !important;
}

.imageSelectorContainer button.red--text {
  height: 3rem;
}

.imageSelectorContainer button.red--text:hover {
  color: white !important;
}
</style>
